// src/components/Navbar.jsx
import React from "react";
import styled from "styled-components";
import { FaBars, FaUserCircle, FaSignOutAlt } from "react-icons/fa";

const Nav = styled.header`
  height: 60px;
  width: 100%;
  background: #ff7a2a;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1200;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Hamburger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  padding: 6px;

  @media(min-width: 992px) {
    display: none; /* hide on desktop */
  }
`;

const Brand = styled.h1`
  color: #fff;
  font-size: 18px;
  margin: 0;
  font-weight: 700;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  margin-right: 2.5rem  ;
`;

const ProfileName = styled.span`
  font-weight: 600;

  @media(max-width: 480px) {
    display: none;
  }
`;

const LogoutBtn = styled.button`
  background: #fff;
  color: #ff7a2a;
  border: none;
  padding: 6px 10px;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
`;

const Navbar = ({ onToggleSidebar, onLogout }) => {
  return (
    <Nav>
      <Left>
        <Hamburger aria-label="Toggle menu" onClick={onToggleSidebar}>
          <FaBars />
        </Hamburger>
        <Brand>DATA ANALYSIS</Brand>
      </Left>

      <Right>
        <FaUserCircle size={24} />
        <ProfileName>Profile</ProfileName>
        <LogoutBtn onClick={onLogout} title="Logout">
          <FaSignOutAlt style={{ verticalAlign: "middle" }} />&nbsp;Logout
        </LogoutBtn>
      </Right>
    </Nav>
  );
};

export default Navbar;
